
import { Link } from 'react-router-dom';
import { Cpu, Facebook, Instagram, Twitter, Youtube, FileText, Linkedin, Star } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gaming-dark border-t border-gaming-light-gray/20 pt-12 pb-6">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <Cpu className="h-6 w-6 text-gaming-blue" />
              <span className="text-xl font-bold font-orbitron text-white">BattleforgePC</span>
            </div>
            <p className="text-gray-400 mb-4">
              Custom high-performance gaming computers, workstations, and components built for enthusiasts by enthusiasts.
            </p>
            <div className="flex items-center space-x-4">
              <a href="https://facebook.com/battleforgepc" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gaming-blue" aria-label="Facebook">
                <Facebook size={18} />
              </a>
              <a href="https://twitter.com/battleforgepc" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gaming-blue" aria-label="Twitter">
                <Twitter size={18} />
              </a>
              <a href="https://instagram.com/battleforgepc" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gaming-blue" aria-label="Instagram">
                <Instagram size={18} />
              </a>
              <a href="https://youtube.com/channel/battleforgepc" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gaming-blue" aria-label="YouTube">
                <Youtube size={18} />
              </a>
              <a href="https://linkedin.com/company/battleforgepc" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gaming-blue" aria-label="LinkedIn">
                <Linkedin size={18} />
              </a>
              <a href="https://www.trustpilot.com/review/battleforgepc.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gaming-blue" aria-label="Trustpilot">
                <Star size={18} />
              </a>
              <a 
                href="https://discord.gg/XvMxcv8UbK" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-[#5865F2] text-white p-1 rounded flex items-center gap-1 hover:bg-[#4752C4] transition-colors"
                aria-label="Join our Discord"
              >
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  className="h-4 w-4"
                >
                  <circle cx="9" cy="12" r="1"></circle>
                  <circle cx="15" cy="12" r="1"></circle>
                  <path d="M7.5 7.2C8.4 6.6 9.7 6 12 6c2.3 0 3.6.6 4.5 1.2"></path>
                  <path d="M7.5 16.8c.9.6 2.2 1.2 4.5 1.2 2.3 0 3.6-.6 4.5-1.2"></path>
                  <path d="M15.5 17.2c1.7-0.4 2.4-0.9 2.5-1V19c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2v-2.8c0.1.1.8.6 2.5 1"></path>
                  <path d="M18 13.3v-2.8c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v2.8"></path>
                </svg>
                <span className="text-xs font-medium hidden sm:inline">Join Discord</span>
              </a>
            </div>
          </div>

          {/* Products */}
          <div className="col-span-1">
            <h3 className="text-white font-medium mb-4">Products</h3>
            <ul className="space-y-2">
              <li><Link to="/gaming-pcs" className="text-gray-400 hover:text-gaming-blue">Gaming PCs</Link></li>
              <li><Link to="/workstations" className="text-gray-400 hover:text-gaming-blue">Workstations</Link></li>
              <li><Link to="/customize" className="text-gray-400 hover:text-gaming-blue">PC Configurator</Link></li>
              <li><Link to="/components" className="text-gray-400 hover:text-gaming-blue">Components</Link></li>
                            <li><Link to="/gaming-pcs" className="text-gray-400 hover:text-gaming-blue">Pre-built PCs</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div className="col-span-1">
            <h3 className="text-white font-medium mb-4">Support</h3>
            <ul className="space-y-2">
              <li><Link to="/support#contact" className="text-gray-400 hover:text-gaming-blue">Contact Us</Link></li>
              <li><Link to="/support#faq" className="text-gray-400 hover:text-gaming-blue">FAQs</Link></li>
              <li><Link to="/support#warranty" className="text-gray-400 hover:text-gaming-blue">Warranty</Link></li>
              <li><Link to="/support#returns" className="text-gray-400 hover:text-gaming-blue">Returns</Link></li>
              <li><Link to="/support#status" className="text-gray-400 hover:text-gaming-blue">System Status</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div className="col-span-1">
            <h3 className="text-white font-medium mb-4">Company</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-400 hover:text-gaming-blue">About Us</Link></li>
              <li><Link to="/articles" className="text-gray-400 hover:text-gaming-blue">Articles</Link></li>
              <li><Link to="/about#careers" className="text-gray-400 hover:text-gaming-blue">Careers</Link></li>
              <li><Link to="/about#press" className="text-gray-400 hover:text-gaming-blue">Press</Link></li>
              <li><Link to="/about#partners" className="text-gray-400 hover:text-gaming-blue">Partners</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-6 border-t border-gaming-light-gray/20 text-center md:text-left md:flex md:justify-between md:items-center">
          <p className="text-gray-500 text-sm">
            &copy; {currentYear} BattleforgePC Gaming. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0">
            <ul className="flex flex-wrap justify-center md:justify-end space-x-6 text-sm text-gray-500">
              <li><Link to="/terms" className="hover:text-gaming-blue">Terms</Link></li>
              <li><Link to="/privacy" className="hover:text-gaming-blue">Privacy</Link></li>
              <li><Link to="/sitemap" className="hover:text-gaming-blue flex items-center">
                <FileText className="h-3 w-3 mr-1" />
                Sitemap
              </Link></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
